import {Injectable} from '@angular/core';
import {MissingTranslationHandler, MissingTranslationHandlerParams} from "@ngx-translate/core";

@Injectable({
  providedIn: 'root'
})
export class EmptyMissingTranslationHandler implements MissingTranslationHandler {

  handle(params: MissingTranslationHandlerParams): string {
    console.warn(`Missing translation for key: ${params.key}`);
    return `[MISSING: ${params.key}]`;
  }
}
